export const Brand = [
    {
        "id": 1,
        "name": "Fiat",
        "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/fiat.png"
    },
    {
        "id": 2,
        "name": "Ford",
        "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/ford.png"
    },
    {
        "id": 3,
        "name": "Chevrolet",
        "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/gm.png"
    },
    {
        "id": 4,
        "name": "Volkswagem",
        "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/volkswagen.png"
    },
    {
        "id": 17,
        "name": "Renault",
        "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/renault.png"
    },
    {
        "id": 8,
        "name": "Citroen",
        "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/citroen.png"
    },
    {
        "id": 22,
        "name": "Peugeot",
        "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/peugeot.png"
    },
    {
        "id": 14,
        "name": "Mitsubishi",
        "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/mitsubishi.png"
      },
      {
        "id": 15,
        "name": "Nissan",
        "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/nissan.png"
      },
    {
        "id": 9,
        "name": "Honda",
        "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/honda.png"
    },
    {
        "id": 19,
        "name": "Toyota",
        "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/toyota.png"
    },
    {
        "id": 10,
        "name": "Hyundai",
        "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/hyundai.png"
    },
    {
        "id": 23,
        "name": "Kia Motors",
        "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/kia.png"
    },
    {
      "id": 6,
      "name": "Audi",
      "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/audi.png"
    },
    {
      "id": 7,
      "name": "BMW",
      "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/bmw.png"
    },
    {
      "id": 5,
      "name": "Chery",
      "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/chery.png"
    },
    {
      "id": 24,
      "name": "JAC",
      "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/jac.png"
    },
    {
      "id": 11,
      "name": "Jeep",
      "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/jeep.png"
    },
    {
      "id": 25,
      "name": "Land Rover",
      "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/land-rover.png"
    },
    {
      "id": 12,
      "name": "Lifan",
      "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/lifan.png"
    },
    {
      "id": 13,
      "name": "Mercedes Benz",
      "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/mercedez-bens.png"
    },
    {
        "id": 18,
        "name": "Seat",
        "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/seat.png"
      },
      {
        "id": 26,
        "name": "Suzuki",
        "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/suzuki.png"
      },
      {
        "id": 20,
        "name": "Troller",
        "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/troller.png"
      },
      {
        "id": 21,
        "name": "Volvo",
        "img": "https://appcar-app.s3.amazonaws.com/static/img/car/montadoras/volvo.png"
      }
  ]